import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';


import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import Loader from "../../components/Loader/Loader";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import Paginator from '../../components/Paginator/Paginator';

import "./ProductList.css";


class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: "",
      searchTouched: false,
      products: [],
      active: false,
      showMessage: false,
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalProducts: 0,
      perPage: 10,
      productPage: 1,
      productsLoading: true,
    };
  }

  componentDidMount() {
    this.loadProducts(1);
  }



  loadProducts = (productPage, searchData = "") => {
    if (productPage) {
      this.setState({ productsLoading: true, products: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchProducts($page: Int, $perPage: Int, $searchData: String) {
            allProducts(page: $page, perPage: $perPage, searchData: $searchData) {
              Products {
                code
                persianTitle
                englishTitle
                imageUrl
                status
                categoryTitle
                brandTitle
                brandEnTitle
                totalVariants
              }
              totalProducts
            }
          }
        `,
      variables: {
        page: productPage,
        perPage: this.state.perPage,
        searchData: searchData
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            products: resData.data.allProducts.Products,
            totalProducts: resData.data.allProducts.totalProducts,
            productsLoading: false,
            productPage: productPage 
        });
           
      })
      .catch(this.catchError);
  };


  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };


  postInputChangeHandler = (input, value, files) => {
    console.log(value);
    this.setState((prevState) => {
      return {
        searchValue: value,
        loading: false,
      };
    });
  };


  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        searchTouched: true,          
      };
    });
  };

  cancelPostChangeHandler = () => {
    this.setState({
      searchValue: "",
      searchTouched: false
    });
    this.loadProducts(1);
  };

  acceptPostChangeHandler = () => {
    this.loadProducts(1, this.state.searchValue);     
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelProductHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelProductHandler}
          onAcceptModal={this.onDeleteProductTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="مدیریت محصولات" 
              headerDescription="برای ویرایش و مدیریت مشخصات ، گروه ، تصویر محصولات و درج تنوع (گارانتی ، به همراه رنگ یا سایز) از این قسمت استفاده نمایید"
            />
            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                  <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                    <div className="mn-ui-form__row mn-ui-form__row_padding">
                      <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                        <div className="c-ui-paginators">
                          <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                              <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                              <div className="field-wrapper ui-select ui-select__container">
                                <div className="mn-ui-input">
                                  {/* <input  className="mn-ui-input__field mn-ui-input__field--order"/> */}
                                  <input
                                    className={[
                                      "mn-content-input__origin valid",
                                      this.state.searchTouched ? "touched" : "untouched",
                                    ].join(" ")}
                                    type="text"
                                    name="search"
                                    id="search"
                                    placeholder="عبارت مورد نظرتان را وارد کنید..."
                                    onChange={(e) =>
                                      this.postInputChangeHandler("search", e.target.value, e.target.files)
                                    }
                                    onBlur={this.inputBlurHandler.bind(this, "search")}
                                    // valid={this.state.postForm["search"].valid}
                                    value={this.state.searchValue || ""}
                                  />
                                </div>                                        
                              </div>
                          </div>
                          <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                            <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton" disabled={this.state.searchValue.length<2} onClick={this.acceptPostChangeHandler}>
                              <span className="mn-seach__btn">جستجو</span>
                            </button>
                            <button type="button" className="mn-content-categories__search-reset" id="resetButton" disabled={this.state.searchValue.length<2} onClick={this.cancelPostChangeHandler}></button>
                          </div>
                        </div>
                        <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                          <Link to='/add-product' className="mn-product_link">
                            <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                              ایجاد کالای جدید
                            </div>
                          </Link>
                          </div>
                      </div>
                    </div>
                  </form>
                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        <Link to='/add-product' className="mn-product_link">
                                <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                    ایجاد کالای جدید
                                </div>
                        </Link>

                        <Paginator
                          onNext={this.loadProducts.bind(this)}
                          lastPage={Math.ceil(this.state.totalProducts / this.state.perPage)}
                          totalProducts={this.state.totalProducts}
                          currentPage={this.state.productPage}
                        />
                        {/* <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom"> 
                            <Link to='/add-product' className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                <span className="mn-seach__btn">ایجاد برند جدید</span>
                            </Link>
                         </div> */}
                         
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.productsLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table   js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">تصویر کالا</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">عنوان و کد کالا</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">گروه کالایی</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable"> برند کالا </span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">وضعيت</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">تعداد تنوع</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable"></span>
                                    </th>
                                </tr>
                            </thead>


                            <tbody>
                                {this.state.products !== [] && (
                                <Fragment>
                                    {this.state.products.map((data, index) => (
                                    <tr key={index}>
                                        <td className="c-ui-table__cell c-ui-table__cell--smaller">
                                            {index + 1}
                                        </td>

                                        <td className="c-ui-table__cell">
                                            <div className="mn-content-upload__img-container mn-content-upload__img-container-noborder">
                                                <img src={'https://api.shirazpc.com/'+data.imageUrl} alt="" className="mn-content-upload__img js-upload-thumb"/>
                                            </div>
                                        </td>
                                        <td className="c-ui-table__cell c-ui-table__cell-desc c-ui--pt-15 c-ui--pb-15">
                                            <div className="uk-flex uk-flex-column">
                                                <Link to='/add-product' className="mn-product_link">
                                                    <span className="c-wallet__body-card-row-item c-ui--fit c-ui--initial">
                                                        {data.persianTitle}
                                                    </span>
                                                    <span className="c-wallet__body-card-row-item c-ui--fit c-ui--initial">
                                                        {data.englishTitle}
                                                    </span>
                                                </Link>
                                                <div className="uk-flex">
                                                    <span className="mn-mega-table-shp c-ui--fit c-ui--nowrap">
                                                        SHP-{data.code}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="c-ui-table__cell">{data.categoryTitle}</td>
                                        
                                        <td className="c-ui-table__cell ">{data.brandTitle+" "+data.brandEnTitle}</td>
                                        
                                        <td className="c-ui-table__cell">
                                            <span className="mn-row__status-ui edit">
                                                {data.status==1?"فعال":""}
                                            </span>
                                        </td>

                                        <td className="c-ui-table__cell">{data.totalVariants}</td>

                                        <td className="c-ui-table__cell">
                                            <div className="uk-flex uk-flex-right uk-flex-middle">
                                                <Link className="uk-padding-remove mn-product_link" to={"/product/edit/"+data.code}>
                                                    <div className="c-mega-campaigns-join-list__container-table-btn c-mega-campaigns-join-list__container-table-btn--small-edit c-ui--mr-10 js-tool-tip-desc" aria-expanded="false"></div>
                                                    <div className="c-rating-chart__description-tooltip c-mega-campaigns-join-list__container-table-btn-tooltip uk-text-nowrap uk-dropdown uk-dropdown-stack" uk-dropdown="boundary: .js-tool-tip-desc; pos: bottom-center;delay-hide: 0;offset: 10;" style={{left: '89.4px', top: '82.5333px'}}>ویرایش محصول</div>
                                                </Link>
                                                <Link className="uk-padding-remove mn-product_link" to={"/create/product/variant/"+data.code}>
                                                    <div className="c-mega-campaigns-join-list__container-table-btn c-mega-campaigns-join-list__container-table-btn--view c-ui--mr-10 js-tool-tip-desc" aria-expanded="false"></div>
                                                    <div className="c-rating-chart__description-tooltip c-mega-campaigns-join-list__container-table-btn-tooltip uk-text-nowrap uk-dropdown" uk-dropdown="boundary: .js-tool-tip-desc; pos: bottom-center;delay-hide: 0;offset: 10;" style={{left: '39.8px', top: '82.5333px'}}>افزودن تنوع</div>
                                                </Link>
                                            </div>
                                        </td>

                                    </tr>
                                    ))}
                                </Fragment>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        <Link to='/add-product' className="mn-product_link">
                                <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                    ایجاد کالای جدید
                                </div>
                        </Link>

                        <Paginator
                          onNext={this.loadProducts.bind(this)}
                          lastPage={Math.ceil(this.state.totalProducts / this.state.perPage)}
                          totalProducts={this.state.totalProducts}
                          currentPage={this.state.productPage}
                        />
                    </div>
                    {this.state.productsLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )} 
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default ProductList;
